import { Box, IconButton, Switch, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { FC } from 'react';

import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Card, Tables } from 'src/shared/components/index';
import { AdminData } from '../models';
import { OrganizationData } from 'src/modules/Organization/models';
import { I18N } from 'src/shared/constants/constants';
import { useSelector, useDispatch } from 'react-redux';
import { selectUserState } from 'src/auth/login/services/userSlice';

interface AdminManagementTableProps {
  className?: string;
  handleEditIconClick(row: any): void;
  handleDeleteIconClick(email: any): void;
  handleSwitchIconClick(email: any): void;
  inputAminUserData: AdminData[];
}

const AdminManagementTable: FC<AdminManagementTableProps> = ({
  handleEditIconClick,
  handleDeleteIconClick,
  handleSwitchIconClick,
  inputAminUserData
}) => {
  const { userData } = useSelector(selectUserState);

  const handleEditIconClickEvent = (row) => {
    handleEditIconClick(row);
  };

  const handleSwitchIconClickEvent = (row) => {
    handleSwitchIconClick(row);
  };

  const handleDeleteIconClickEvent = (row) => {
    handleDeleteIconClick(row);
  };

  const { t } = useTranslation(I18N.DEFAULT);
  const columns: GridColDef[] = [
    {
      field: ' ',
      headerName: ' ',
      sortable: false,
      type: 'string',
      flex: 0.1
    },
    {
      field: t('enable'),
      sortable: false,
      flex: 0.8,

      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <>
            {userData?.id == params?.id ? null : (
              <Tooltip title={t('enable-disable')} arrow>
                <Switch
                  checked={params.row.isEnabled}
                  onClick={() => handleSwitchIconClickEvent(params.row)}
                />
              </Tooltip>
            )}
          </>
        );
      }
    },
    {
      field: 'email',
      headerName: t('user'),
      filterable: false,
      flex: 2.1
    },
    {
      field: 'role.roleName',
      sortable: true,
      headerName: t('role'),
      flex: 1.1,
      valueGetter: (params) => {
        return `${params.row.role.roleName || ''}`;
      }
    },
    {
      field: 'tenants',
      sortable: true,
      headerName: t('organizations'),
      flex: 2.5,
      valueGetter: (params) => {
        const orgList =
          params.row.tenants.length > 0
            ? params.row.tenants.reduce(
                (accumulator: string, currentValue: OrganizationData) =>
                  `${accumulator} ${currentValue.tenantName},`,
                ''
              )
            : '';

        return orgList.length > 0
          ? orgList.substring(0, orgList.length - 1)
          : orgList;
      }
    },
    {
      field: t('actions'),
      sortable: false,
      width: 100,
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <>
            <Tooltip title={t('delete')} arrow>
              <IconButton
                color="inherit"
                size="small"
                className="RecentOrderDeleteButton"
                onClick={() => handleDeleteIconClickEvent(params.row.email)}
              >
                <DeleteTwoToneIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title={t('edit')} arrow>
              <IconButton
                className="RecentOrderEditButton ml-7"
                color="inherit"
                size="small"
                onClick={() => handleEditIconClickEvent(params.row)}
              >
                <EditTwoToneIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </>
        );
      }
    }
  ];

  return (
    <>
      <Tables
        rows={inputAminUserData}
        columns={columns}
        checkboxSelection={false}
      />
    </>
  );
};

AdminManagementTable.propTypes = {
  inputAminUserData: PropTypes.array.isRequired
};

AdminManagementTable.defaultProps = {
  inputAminUserData: []
};

export default AdminManagementTable;
